import * as React from 'react';
import { createElement } from 'react';
import { appListAuthorityPage } from '../../http/api';
import './index.scss';
import baseURL from '../../http/url';
export default class Application extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            dataArr: [],
        };
    }
    componentDidMount() {
        this.appListAuthorityPageData(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.limit !== this.props.limit)
            this.appListAuthorityPageData(nextProps);
    }
    appListAuthorityPageData = (nextProps) => {
        const params = {
            pageSize: nextProps.limit,
            pageNum: 1
        };
        appListAuthorityPage(params).then(({ data, resultCode }) => {
            if (resultCode === 200) {
                this.setState({
                    dataArr: data.list.map(item => {
                        return {
                            appName: item.appName,
                            appId: item.appId,
                            appImg: `${baseURL.url}/image/${item.appImg}`,
                            appLogoutUrl: item.appLogoutUrl
                        };
                    })
                });
            }
        });
    };
    link(item) {
        if (item.appLogoutUrl)
            window.open(item.appLogoutUrl, '_blank');
    }
    render() {
        return (createElement("div", { ...this.props, style: { display: 'flex', ...this.props.style } }, this.state.dataArr.map(item => createElement("div", { className: "media-card", onClick: () => this.link(item) },
            createElement("img", { src: item.appImg }),
            createElement("div", null, item.appName)))));
    }
}
;
